import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createRespondentAdministratorAPI,
  updateRespondentAdministratorAPI,
  deleteRespondentAdministratorAPI,
  getRespondentAdministratorByCaseIDAPI,
  deleteRespondentAdministratorDocumentAPI,
} from "../../../api/respondentAdministrator_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

export const getRespondentAdministratorByCaseIDAction = createAsyncThunk(
  "respondentAdministrator/getRespondentAdministratorByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getRespondentAdministratorByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createRespondentAdministratorAction = createAsyncThunk(
  "respondentAdministrator/createRespondentAdministrator",
  async (respondentAdministratorData, { rejectWithValue }) => {
    const response = await createRespondentAdministratorAPI(
      respondentAdministratorData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateRespondentAdministratorAction = createAsyncThunk(
  "respondentAdministrator/updateRespondentAdministrator",
  async (
    { respondentAdministratorID, respondentAdministratorData },
    { rejectWithValue },
  ) => {
    const response = await updateRespondentAdministratorAPI(
      respondentAdministratorID,
      respondentAdministratorData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteRespondentAdministratorAction = createAsyncThunk(
  "respondentAdministrator/deleteRespondentAdministrator",
  async (respondentAdministratorID, { rejectWithValue }) => {
    const response = await deleteRespondentAdministratorAPI(
      respondentAdministratorID,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteRespondentAdministratorDocumentAction = createAsyncThunk(
  "respondentAdministrator/deleteRespondentAdministratorDocument",
  async ({ documentID }, { rejectWithValue }) => {
    const response = await deleteRespondentAdministratorDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
